import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

export function usePerformansBolumKontrol(
  bolumId: number | null | undefined,
  firmaAdi: string | null,
  raporYili: number | null
) {
  const [atanmisPerformanslar, setAtanmisPerformanslar] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchAtanmisPerformanslar = async () => {
      if (!bolumId || !firmaAdi || !raporYili) {
        setAtanmisPerformanslar([]);
        return;
      }
      setIsLoading(true);
      try {
        const { data, error } = await supabase
          .from('performans_bolum_atamalari')
          .select('modul_id')
          .eq('sorumlu_bolum_id', bolumId)
          .eq('firma_adi', firmaAdi)
          .eq('raporlama_yili', raporYili);

        if (error) throw error;
        setAtanmisPerformanslar(data?.map(d => d.modul_id) || []);
      } catch (err) {
        console.error('❌ Performans atama kontrolü hatası:', err);
        setAtanmisPerformanslar([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAtanmisPerformanslar();
  }, [bolumId, firmaAdi, raporYili]);

  const hasAnyAssignment = atanmisPerformanslar.length > 0;

  return {
    atanmisPerformanslar,
    hasAnyAssignment,
    isLoading
  };
}
